// extracted by mini-css-extract-plugin
export default {"SettingsPage":"RegistrySettingsPage-styles__SettingsPage__s1zBw","isLoading":"RegistrySettingsPage-styles__isLoading__KTcLZ","shimmer":"RegistrySettingsPage-styles__shimmer__JDsiq"};